module.exports = ".audiotag {\r\n    float: right;\r\n    right: 3.4em;\r\n    top: -3px;\r\n    position: relative;\r\n}"